import axios from "axios";
import { config } from './_config';

export const AwsApiService = axios.create({
    baseURL: config.awsBaseUrl
});

export const AzureApiService = axios.create({
    baseURL: config.azureBaseUrl
});